import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";

var _dec, _class, _class2, _temp;

/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { deprecated } from '@instructure/ui-react-utils';
import { RadioInput as UIRadioInput } from '@instructure/ui-radio-input';
/**
---
category: components/deprecated
id: DeprecatedRadioInput
---
**/

var RadioInput = (_dec = deprecated('7.0.0', null, 'Use RadioInput from ui-radio-input instead.'), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  _inherits(RadioInput, _Component);

  function RadioInput() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RadioInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RadioInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this._radioInput = null;
    return _this;
  }

  _createClass(RadioInput, [{
    key: "focus",
    value: function focus() {
      this._radioInput && this._radioInput.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(UIRadioInput, Object.assign({
        ref: function ref(component) {
          _this2._radioInput = component;
        }
      }, this.props));
    }
  }, {
    key: "id",
    get: function get() {
      return this._radioInput && this._radioInput.id;
    }
  }, {
    key: "focused",
    get: function get() {
      return this._radioInput && this._radioInput.focused;
    }
  }, {
    key: "checked",
    get: function get() {
      return this._radioInput && this._radioInput.checked;
    }
  }]);

  RadioInput.displayName = "RadioInput";
  return RadioInput;
}(Component), _class2.propTypes = {
  label: PropTypes.node.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,

  /**
   * Whether or not to disable the input
   */
  disabled: PropTypes.bool,

  /**
   * Works just like disabled but keeps the same styles as if it were active
   */
  readOnly: PropTypes.bool,
  variant: PropTypes.oneOf(['simple', 'toggle']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  context: PropTypes.oneOf(['success', 'warning', 'danger', 'off']),
  inline: PropTypes.bool,
  onClick: PropTypes.func,
  onChange: PropTypes.func
}, _class2.defaultProps = {
  onClick: function onClick(event) {},
  onChange: function onChange(event) {},
  variant: 'simple',
  size: 'medium',
  disabled: false,
  inline: false,
  context: 'success',
  readOnly: false,
  checked: void 0,
  id: void 0,
  name: void 0,
  value: void 0
}, _temp)) || _class);
export default RadioInput;
export { RadioInput };